/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import { TableColumn, TableProps } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { ReactNode } from 'react';
import { CatalogTileGrid } from './catalogTile/CatalogTileGrid';
import { CatalogTableCustom } from './catalogTable/CatalogTable';

/**
 * Props for {@link CatalogList}.
 *
 * @public
 */

export type CatalogView = 'table' | 'grid' | 'group';
export interface CatalogListProps {
  viewAs?: CatalogView;
  columns?: TableColumn<CatalogTableRow>[];
  actions?: TableProps<CatalogTableRow>['actions'];
  tableOptions?: TableProps<CatalogTableRow>['options'];
  emptyContent?: ReactNode;
}

/** @public */
export const CatalogList = (props: CatalogListProps) => {
  const { viewAs, columns, actions, tableOptions, emptyContent } = props;

  const getContentByView = (): JSX.Element => {
    switch (viewAs) {
      case 'grid':
        return <CatalogTileGrid />;
      case 'table':
        return (
          <CatalogTableCustom
            columns={columns}
            actions={actions}
            tableOptions={tableOptions}
            emptyContent={emptyContent}
          />
        );
      default:
        return <CatalogTileGrid />;
    }
  };

  return getContentByView();
};
